import { Component } from '@theme/component';

class SecurProductSupport extends Component {
  #events;
  #lastFocus;
  #scrollContainer;
  #overflow;
  #restoreFrame;

  connectedCallback() {
    super.connectedCallback();
    this.#events?.abort();
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    const dialog = this.querySelector('[data-sc-support-dialog]');
    const panel = this.querySelector('[data-sc-support-panel]');
    const trigger = this.querySelector('[data-sc-support-open]');
    const fallback = this.querySelector('details');
    const form = this.querySelector('form');
    const storageKey = `sc-support-${this.dataset.supportKey}`;
    if (!(dialog instanceof HTMLDialogElement) || !panel || !trigger || !form) return;
    dialog.append(panel);
    fallback.open = false;
    const open = () => {
      if (dialog.open) return;
      this.#lastFocus = document.activeElement === document.body ? trigger : document.activeElement;
      const wrapper = this.closest('.page-wrapper');
      this.#scrollContainer = wrapper && wrapper.scrollHeight > wrapper.clientHeight && ['auto','scroll'].includes(getComputedStyle(wrapper).overflowY) ? wrapper : document.body;
      this.#overflow = this.#scrollContainer.style.overflow;
      this.#scrollContainer.style.overflow = 'hidden';
      dialog.showModal();
      const outcome = this.querySelector('[data-sc-support-success],[data-sc-support-errors]');
      if (outcome instanceof HTMLElement) outcome.focus({ preventScroll: true });
    };
    trigger.addEventListener('click', (event) => { event.preventDefault(); open(); }, options);
    trigger.addEventListener('keydown', (event) => {
      if (!['Enter',' '].includes(event.key)) return;
      event.preventDefault();
      open();
    }, options);
    this.querySelector('[data-sc-support-close]')?.addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => {
      if (this.#scrollContainer) this.#scrollContainer.style.overflow = this.#overflow ?? '';
      const focus = this.#lastFocus instanceof HTMLElement && this.#lastFocus.isConnected ? this.#lastFocus : trigger;
      focus.focus({ preventScroll: true });
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, options);
    const topics = [...this.querySelectorAll('[data-sc-support-topic]')];
    const subject = this.querySelector('[data-sc-support-subject]');
    const question = this.querySelector('textarea');
    topics.forEach((topic) => topic.addEventListener('click', () => {
      topics.forEach((button) => button.setAttribute('aria-pressed', String(button === topic)));
      if (subject instanceof HTMLInputElement) subject.value = topic.dataset.scSupportTopic;
      question?.focus({ preventScroll: true });
    }, options));
    form.addEventListener('submit', (event) => {
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        const wrapper = this.closest('.page-wrapper');
        try { sessionStorage.setItem(storageKey, JSON.stringify({ top: wrapper?.scrollTop || window.scrollY, at: Date.now() })); } catch {}
        const button = this.querySelector('[data-sc-support-submit]');
        if (button) { button.setAttribute('aria-busy','true'); button.textContent = button.dataset.sendingLabel; }
      });
    }, options);
    const outcome = this.querySelector('[data-sc-support-success],[data-sc-support-errors]');
    if (outcome) {
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); sessionStorage.removeItem(storageKey); } catch {}
      this.#restoreFrame = requestAnimationFrame(() => {
        const wrapper = this.closest('.page-wrapper');
        if (saved && Date.now() - saved.at < 1800000 && Number.isFinite(saved.top)) {
          if (wrapper) wrapper.scrollTop = saved.top;
          else window.scrollTo({ top: saved.top, behavior: 'instant' });
        }
        open();
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.querySelector('dialog[open]') && this.#scrollContainer) this.#scrollContainer.style.overflow = this.#overflow ?? '';
    this.#events?.abort();
    cancelAnimationFrame(this.#restoreFrame);
  }
}

if (!customElements.get('secur-product-support')) customElements.define('secur-product-support', SecurProductSupport);
